import { Box, Typography } from '@mui/material';

const InvestInTheFuture = () => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4">Invest in the Future</Typography>
    </Box>
  );
};

export default InvestInTheFuture; 